export const MAP_REQUEST_PAGE_SIZE = 200;
export const LIST_REQUEST_PAGE_SIZE = 18;

export const TULUM_AND_PLAYA_DEL_CARMEN = [
  'f53ffd5a-44a3-4142-8f16-60134c471c7c', // Engel & Völkers Tulum
  '54bb66f5-eee6-4724-862b-3317a85a5721', // Engel & Völkers Playa del Carmen
];

export const BAHAMAS_SHOP_IDS = [
  'dde38d5b-1c46-4618-a3d6-cc8e9c7b2ee1',
  'cadd82c1-5f7a-49f1-880a-429efd5688fa',
];

export const SHORT_LOCATION_TITLE_EXCEPTIONS = ['eleuthera', 'andros island'];

export const SQ_FT_TO_M2 = 0.092903; // conversion factor from sq.ft to m^2
export const M2_TO_SQ_FT = 10.7639; // conversion factor from m^2 to sq.ft

export const ESTABLISHMENTS_EXCEPTION: (google.maps.places.AutocompletePrediction & {
  domain: string;
})[] = [
  {
    description: 'Andros Island, The Bahamas',
    matched_substrings: [{ length: 6, offset: 0 }],
    place_id: 'ChIJPQBNCMXOKIkRSWl-mF_9SNc',
    structured_formatting: {
      main_text: 'Andros Island',
      main_text_matched_substrings: [{ length: 6, offset: 0 }],
      secondary_text: 'The Bahamas',
    },
    terms: [
      { offset: 0, value: 'Andros Island' },
      { offset: 15, value: 'The Bahamas' },
    ],
    types: ['natural_feature', 'establishment'],
    domain: 'bahamas',
  },
];

export enum PAGE_TYPE {
  SIMILAR_LISTINGS = 'similarListings',
}

export enum SearchResultType {
  EMPTY = 'EMPTY',
  FETCHING = 'FETCHING',
  COMPLETED = 'COMPLETED',
  UNKNOWN = 'UNKNOWN',
}

export const DEFAULT_EXCHANGE_RATES: Record<string, number> = {
  ARS: 998.2854950000001,
  BSD: 1,
  BZD: 2.021355,
  CAD: 1.40149,
  CLP: 978.83377,
  COP: 4433.302665,
  CRC: 511.906965,
  EUR: 0.94503,
  KYD: 0.83333,
  MXN: 20.430725,
  PEN: 3.793485,
  UYU: 42.404915,
  USD: 1,
};
